export class MockedVitochargeFeatures {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.2',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.2',
        timestamp: '2022-10-11T12:01:03.260Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          build: {
            value: 89,
            unit: '',
            type: 'number',
          },
          family: {
            value: 26,
            unit: '',
            type: 'number',
          },
          revision: {
            value: 2038,
            unit: '',
            type: 'number',
          },
          version: {
            value: 500,
            unit: '',
            type: 'number',
          },
          value: {
            value: '0000.0000.0000.0000',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.3.version.firmware',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.3.version.firmware',
        timestamp: '2022-10-11T12:01:03.269Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          family: {
            value: 26,
            unit: '',
            type: 'number',
          },
          revision: {
            value: 702,
            unit: '',
            type: 'number',
          },
          version: {
            value: 600,
            unit: '',
            type: 'number',
          },
          assemblyVariant: {
            value: 1,
            unit: '',
            type: 'number',
          },
          value: {
            value: '0000.0000.0000.0000',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.2.version.hardware',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.2.version.hardware',
        timestamp: '2022-10-11T12:01:03.263Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.3',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.3',
        timestamp: '2022-10-11T12:01:03.265Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'hybrid',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.configuration.systemType',
        gatewayId: gatewaySerial,
        feature: 'ess.configuration.systemType',
        timestamp: '2022-10-11T12:01:03.226Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          total: {
            type: 'number',
            value: 123,
            unit: 'watt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.power.consolidated',
        gatewayId: gatewaySerial,
        feature: 'ess.power.consolidated',
        timestamp: '2022-10-11T16:29:51.187Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: '7727520108282102',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.3.etn',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.3.etn',
        timestamp: '2022-10-11T12:01:03.267Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.status.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.status.active',
        timestamp: '2022-10-10T23:12:11.563Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 25,
            unit: 'percent',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ess.configuration.backupBox/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 100,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.configuration.backupBox',
        gatewayId: gatewaySerial,
        feature: 'ess.configuration.backupBox',
        timestamp: '2022-10-11T12:01:03.227Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.0',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.0',
        timestamp: '2022-10-11T12:01:03.236Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.meter.0',
        gatewayId: gatewaySerial,
        feature: 'ess.meter.0',
        timestamp: '2022-10-11T12:01:03.234Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          vinList: {
            type: 'array',
            value: ['7727520108275104', '7727520108274107', '7727520108281105', '7727520108282102'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.serial.internalComponents',
        gatewayId: gatewaySerial,
        feature: 'device.serial.internalComponents',
        timestamp: '2022-10-11T12:01:03.291Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 994,
            unit: 'wattHour',
          },
          currentWeek: {
            type: 'number',
            value: 2622,
            unit: 'wattHour',
          },
          currentMonth: {
            type: 'number',
            value: 17327,
            unit: 'wattHour',
          },
          currentYear: {
            type: 'number',
            value: 52247,
            unit: 'wattHour',
          },
          lifeCycle: {
            type: 'number',
            value: 52247,
            unit: 'wattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.transfer.discharge.cumulated',
        gatewayId: gatewaySerial,
        feature: 'ess.transfer.discharge.cumulated',
        timestamp: '2022-10-11T16:29:58.254Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 1747,
            unit: 'wattHour',
          },
          currentWeek: {
            type: 'number',
            value: 3445,
            unit: 'wattHour',
          },
          currentMonth: {
            type: 'number',
            value: 18887,
            unit: 'wattHour',
          },
          currentYear: {
            type: 'number',
            value: 61786,
            unit: 'wattHour',
          },
          lifeCycle: {
            type: 'number',
            value: 61786,
            unit: 'wattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.transfer.charge.cumulated',
        gatewayId: gatewaySerial,
        feature: 'ess.transfer.charge.cumulated',
        timestamp: '2022-10-11T15:47:35.511Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '7470705200387121',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.etn',
        gatewayId: gatewaySerial,
        feature: 'device.etn',
        timestamp: '2022-10-11T12:01:03.201Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          family: {
            type: 'number',
            value: 79,
            unit: '',
          },
          version: {
            type: 'number',
            value: 502,
            unit: '',
          },
          revision: {
            type: 'number',
            value: 2211,
            unit: '',
          },
          build: {
            type: 'number',
            value: 4,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.firmware.version',
        gatewayId: gatewaySerial,
        feature: 'device.firmware.version',
        timestamp: '2022-10-11T12:01:03.175Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: [
              {
                busAddress: 1,
                busType: 'CanInternal',
                deviceObjectProperty: 'EMCUMaster',
                deviceFunction: 'Nothing',
                softwareVersion: '0024.0502.2207.0188',
                hardwareVersion: '0024.0603.0101.0001',
                etn: '7470705200387121',
              },
              {
                busAddress: 97,
                busType: 'CanExternal',
                deviceObjectProperty: 'EnergyMeter',
                deviceFunction: 'Yes',
                softwareVersion: '0027.0102.0001.0005',
                hardwareVersion: '0027.0100.0000.0000',
                etn: '0102000211604670',
              },
              {
                busAddress: 96,
                busType: 'CanInternal',
                deviceObjectProperty: 'Inverter',
                deviceFunction: 'Yes',
                softwareVersion: '0100.0500.2208.30792',
                hardwareVersion: '0100.0001.0000.0010',
                etn: '0000000287454020',
              },
              {
                busAddress: 57,
                busType: 'CanInternal',
                deviceObjectProperty: 'BMCU',
                deviceFunction: 'Vitocharge',
                softwareVersion: '0022.0502.2207.0148',
                hardwareVersion: '0022.0603.0101.0001',
                etn: '7470705200387121',
              },
              {
                busAddress: 67,
                busType: 'CanRaw',
                deviceObjectProperty: 'CSC',
                deviceFunction: 'Yes',
                softwareVersion: '0026.0500.2038.0089',
                hardwareVersion: '0026.0600.0702.0001',
                etn: '7727520108275104',
              },
              {
                busAddress: 66,
                busType: 'CanRaw',
                deviceObjectProperty: 'CSC',
                deviceFunction: 'Yes',
                softwareVersion: '0026.0500.2038.0089',
                hardwareVersion: '0026.0600.0702.0001',
                etn: '7727520108274107',
              },
              {
                busAddress: 65,
                busType: 'CanRaw',
                deviceObjectProperty: 'CSC',
                deviceFunction: 'Yes',
                softwareVersion: '0026.0500.2038.0089',
                hardwareVersion: '0026.0600.0702.0001',
                etn: '7727520108281105',
              },
              {
                busAddress: 64,
                busType: 'CanRaw',
                deviceObjectProperty: 'CSC',
                deviceFunction: 'Yes',
                softwareVersion: '0026.0500.2038.0089',
                hardwareVersion: '0026.0600.0702.0001',
                etn: '7727520108282102',
              },
              {
                busAddress: 59,
                busType: 'CanInternal',
                deviceObjectProperty: 'HMI',
                deviceFunction: 'No',
                softwareVersion: '0051.0527.2208.0000',
                hardwareVersion: '0018.0528.2207.0001',
                etn: '7470706201427120',
              },
              {
                busAddress: 58,
                busType: 'CanInternal',
                deviceObjectProperty: 'BackendGateway',
                deviceFunction: 'Nothing',
                softwareVersion: '0010.0508.2238.0001',
                hardwareVersion: '0010.0001.0000.0000',
                etn: gatewaySerial,
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.busTopology',
        gatewayId: gatewaySerial,
        feature: 'device.busTopology',
        timestamp: '2022-10-11T12:01:03.295Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          total: {
            type: 'number',
            value: 99,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.stateOfCharge.consolidated',
        gatewayId: gatewaySerial,
        feature: 'ess.stateOfCharge.consolidated',
        timestamp: '2022-10-11T16:29:11.892Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 1,
            unit: 'watt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/pcc.transfer.power.exchange',
        gatewayId: gatewaySerial,
        feature: 'pcc.transfer.power.exchange',
        timestamp: '2022-10-11T16:29:46.151Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.info.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.raw',
        timestamp: '2022-10-11T12:01:03.197Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.warnings.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.active',
        timestamp: '2022-10-10T23:12:11.553Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          build: {
            value: 89,
            unit: '',
            type: 'number',
          },
          family: {
            value: 26,
            unit: '',
            type: 'number',
          },
          revision: {
            value: 2038,
            unit: '',
            type: 'number',
          },
          version: {
            value: 500,
            unit: '',
            type: 'number',
          },
          value: {
            value: '0000.0000.0000.0000',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.1.version.firmware',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.1.version.firmware',
        timestamp: '2022-10-11T12:01:03.259Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          total: {
            type: 'number',
            value: 24,
            unit: 'watt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.inverter.ac.power.consolidated',
        gatewayId: gatewaySerial,
        feature: 'ess.inverter.ac.power.consolidated',
        timestamp: '2022-10-11T16:29:56.235Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          phaseOne: {
            type: 'number',
            value: -24,
            unit: 'watt',
          },
          phaseTwo: {
            type: 'number',
            value: -14,
            unit: 'watt',
          },
          phaseThree: {
            type: 'number',
            value: -20,
            unit: 'watt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/pcc.ac.reactive.power',
        gatewayId: gatewaySerial,
        feature: 'pcc.ac.reactive.power',
        timestamp: '2022-10-11T16:29:53.207Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: '7727520108281105',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.2.etn',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.2.etn',
        timestamp: '2022-10-11T12:01:03.261Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          enabled: {
            type: 'array',
            value: [0, 1, 2, 3],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery',
        gatewayId: gatewaySerial,
        feature: 'ess.battery',
        timestamp: '2022-10-11T12:01:03.235Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: '7727520108274107',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.1.etn',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.1.etn',
        timestamp: '2022-10-11T12:01:03.243Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          total: {
            type: 'number',
            value: 0,
            unit: 'kilowatt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/photovoltaic.production.current.total',
        gatewayId: gatewaySerial,
        feature: 'photovoltaic.production.current.total',
        timestamp: '2022-10-11T16:16:05.154Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.errors.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.errors.raw',
        timestamp: '2022-10-11T12:01:03.191Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: '7727520108275104',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.0.etn',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.0.etn',
        timestamp: '2022-10-11T12:01:03.238Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.warnings.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.raw',
        timestamp: '2022-10-11T12:01:03.196Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.info.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.active',
        timestamp: '2022-10-10T23:12:11.559Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.service.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.active',
        timestamp: '2022-10-10T23:12:11.567Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 8000,
            unit: 'wattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.capacityNominal',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.capacityNominal',
        timestamp: '2022-10-11T12:01:03.286Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          total: {
            type: 'number',
            value: 7,
            unit: 'kilowattpeak',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/photovoltaic.installedPeakPower.consolidated',
        gatewayId: gatewaySerial,
        feature: 'photovoltaic.installedPeakPower.consolidated',
        timestamp: '2022-10-11T12:01:03.213Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 1574600,
            unit: 'wattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/pcc.transfer.feedIn.total',
        gatewayId: gatewaySerial,
        feature: 'pcc.transfer.feedIn.total',
        timestamp: '2022-10-11T15:16:43.258Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.service.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.raw',
        timestamp: '2022-10-11T12:01:03.200Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          stringOne: {
            type: 'number',
            value: 0,
            unit: 'volt',
          },
          stringTwo: {
            type: 'number',
            value: 429.71,
            unit: 'volt',
          },
          stringThree: {
            type: 'number',
            value: 430.801,
            unit: 'volt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/photovoltaic.string.voltage',
        gatewayId: gatewaySerial,
        feature: 'photovoltaic.string.voltage',
        timestamp: '2022-10-11T16:29:58.256Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          family: {
            value: 26,
            unit: '',
            type: 'number',
          },
          revision: {
            value: 702,
            unit: '',
            type: 'number',
          },
          version: {
            value: 600,
            unit: '',
            type: 'number',
          },
          assemblyVariant: {
            value: 1,
            unit: '',
            type: 'number',
          },
          value: {
            value: '0000.0000.0000.0000',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.3.version.hardware',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.3.version.hardware',
        timestamp: '2022-10-11T12:01:03.268Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          mode: {
            type: 'string',
            value: 'deactivated',
          },
          limit: {
            type: 'number',
            value: 70,
            unit: 'percent',
          },
          limitType: {
            type: 'string',
            value: 'static',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/pcc.power.feedInLimitation',
        gatewayId: gatewaySerial,
        feature: 'pcc.power.feedInLimitation',
        timestamp: '2022-10-11T12:01:03.290Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 29.8,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.sensors.temperature.ambient',
        gatewayId: gatewaySerial,
        feature: 'ess.sensors.temperature.ambient',
        timestamp: '2022-10-11T16:29:46.152Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.status.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.status.raw',
        timestamp: '2022-10-11T12:01:03.199Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          family: {
            value: 26,
            unit: '',
            type: 'number',
          },
          revision: {
            value: 702,
            unit: '',
            type: 'number',
          },
          version: {
            value: 600,
            unit: '',
            type: 'number',
          },
          assemblyVariant: {
            value: 1,
            unit: '',
            type: 'number',
          },
          value: {
            value: '0000.0000.0000.0000',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.0.version.hardware',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.0.version.hardware',
        timestamp: '2022-10-11T12:01:03.239Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 36606,
            unit: 'wattHour',
          },
          currentWeek: {
            type: 'number',
            value: 73971,
            unit: 'wattHour',
          },
          currentMonth: {
            type: 'number',
            value: 325584,
            unit: 'wattHour',
          },
          currentYear: {
            type: 'number',
            value: 1036701,
            unit: 'wattHour',
          },
          lifeCycle: {
            type: 'number',
            value: 1036701,
            unit: 'wattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/photovoltaic.production.cumulated',
        gatewayId: gatewaySerial,
        feature: 'photovoltaic.production.cumulated',
        timestamp: '2022-10-11T16:10:11.647Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.errors.active',
        gatewayId: gatewaySerial,
        feature: 'device.errors.active',
        timestamp: '2022-10-10T23:12:11.590Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          build: {
            value: 89,
            unit: '',
            type: 'number',
          },
          family: {
            value: 26,
            unit: '',
            type: 'number',
          },
          revision: {
            value: 2038,
            unit: '',
            type: 'number',
          },
          version: {
            value: 500,
            unit: '',
            type: 'number',
          },
          value: {
            value: '0000.0000.0000.0000',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.0.version.firmware',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.0.version.firmware',
        timestamp: '2022-10-11T12:01:03.240Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          phaseOne: {
            type: 'number',
            value: 0,
            unit: 'ampere',
          },
          phaseTwo: {
            type: 'number',
            value: 0,
            unit: 'ampere',
          },
          phaseThree: {
            type: 'number',
            value: 0,
            unit: 'ampere',
          },
          total: {
            type: 'number',
            value: 0,
            unit: 'ampere',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/pcc.ac.active.current',
        gatewayId: gatewaySerial,
        feature: 'pcc.ac.active.current',
        timestamp: '2022-10-11T15:01:46.127Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          family: {
            type: 'number',
            value: 24,
            unit: '',
          },
          version: {
            type: 'number',
            value: 603,
            unit: '',
          },
          revision: {
            type: 'number',
            value: 101,
            unit: '',
          },
          assemblyVariant: {
            type: 'number',
            value: 1,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.version.hardware',
        gatewayId: gatewaySerial,
        feature: 'ess.version.hardware',
        timestamp: '2022-10-11T12:01:03.212Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          family: {
            value: 26,
            unit: '',
            type: 'number',
          },
          revision: {
            value: 702,
            unit: '',
            type: 'number',
          },
          version: {
            value: 600,
            unit: '',
            type: 'number',
          },
          assemblyVariant: {
            value: 1,
            unit: '',
            type: 'number',
          },
          value: {
            value: '0000.0000.0000.0000',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.1.version.hardware',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.1.version.hardware',
        timestamp: '2022-10-11T12:01:03.256Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/device.zigbee.active/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/device.zigbee.active/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.zigbee.active',
        gatewayId: gatewaySerial,
        feature: 'device.zigbee.active',
        timestamp: '2022-10-11T12:01:01.925Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'ready',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/photovoltaic.status',
        gatewayId: gatewaySerial,
        feature: 'photovoltaic.status',
        timestamp: '2022-10-11T16:02:31.377Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.zigbee.status',
        gatewayId: gatewaySerial,
        feature: 'device.zigbee.status',
        timestamp: '2022-10-11T12:01:03.174Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          stringOne: {
            type: 'number',
            value: 0,
            unit: 'ampere',
          },
          stringTwo: {
            type: 'number',
            value: 0,
            unit: 'ampere',
          },
          stringThree: {
            type: 'number',
            value: 0,
            unit: 'ampere',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/photovoltaic.string.current',
        gatewayId: gatewaySerial,
        feature: 'photovoltaic.string.current',
        timestamp: '2022-10-11T14:27:47.363Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'normOne',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/pcc.state.gridCode',
        gatewayId: gatewaySerial,
        feature: 'pcc.state.gridCode',
        timestamp: '2022-10-11T12:01:03.288Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 33300,
            unit: 'wattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/pcc.transfer.consumption.total',
        gatewayId: gatewaySerial,
        feature: 'pcc.transfer.consumption.total',
        timestamp: '2022-10-11T12:01:03.224Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '7372956201325202',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.serial',
        gatewayId: gatewaySerial,
        feature: 'device.serial',
        timestamp: '2022-10-11T12:01:03.189Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          runtime: {
            type: 'number',
            value: 2671200,
            unit: 'seconds',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.mainECU',
        gatewayId: gatewaySerial,
        feature: 'heating.device.mainECU',
        timestamp: '2022-10-11T12:01:03.222Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          phaseOne: {
            type: 'number',
            value: -2,
            unit: 'watt',
          },
          phaseTwo: {
            type: 'number',
            value: -3,
            unit: 'watt',
          },
          phaseThree: {
            type: 'number',
            value: 6,
            unit: 'watt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/pcc.ac.active.power',
        gatewayId: gatewaySerial,
        feature: 'pcc.ac.active.power',
        timestamp: '2022-10-11T16:29:53.205Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '7372956201325202',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.serial',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.serial',
        timestamp: '2022-10-11T12:01:03.296Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'discharge',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.operationState',
        gatewayId: gatewaySerial,
        feature: 'ess.operationState',
        timestamp: '2022-10-11T15:54:40.273Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.1',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.1',
        timestamp: '2022-10-11T12:01:03.242Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          build: {
            value: 89,
            unit: '',
            type: 'number',
          },
          family: {
            value: 26,
            unit: '',
            type: 'number',
          },
          revision: {
            value: 2038,
            unit: '',
            type: 'number',
          },
          version: {
            value: 500,
            unit: '',
            type: 'number',
          },
          value: {
            value: '0000.0000.0000.0000',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/ess.battery.2.version.firmware',
        gatewayId: gatewaySerial,
        feature: 'ess.battery.2.version.firmware',
        timestamp: '2022-10-11T12:01:03.264Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
    ];
  }
}
